export default __webpack_public_path__ + "static/media/FSad.ebdbf545.svg";